import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'firebase';
import { Router } from '@angular/router';
import { getLocalTranslate } from 'src/app/helpers/global-functions';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit {

  verifyEmail:string = 'Verify Email'
  verifyEmailText:string = 'Verify Email Text'
  logout:string = 'Log Out'

  constructor(
    private authService:AuthService,
    private router:Router
  ) { }

  ngOnInit(): void {
    this.checkAuth()
    this.needTranslate()
  }

  needTranslate(){
    this.verifyEmail = getLocalTranslate('verify-email',this.verifyEmail)
    this.verifyEmailText = getLocalTranslate('verify-email-text',this.verifyEmailText)
    this.logout = getLocalTranslate('logout',this.logout)
    console.log(this.verifyEmail)
    console.log(this.verifyEmailText)
    console.log(this.logout)
  }

  async checkAuth(){
    const user:User = await this.authService.checkAuth().then(result=>{
      return result
    })
    if(user && user.emailVerified){
      this.router.navigate([''])
      return;
    }
    if(!user){
      this.router.navigate(['login'])
      return
    }
    this.authService.sendVerificationMail()
  }

  onLogout(){
    if(confirm("Are you sure to logout!")) {
      this.authService.onLogout()
    }
  }
}
